import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Navbar, Container, Nav } from 'react-bootstrap';
import DarkModeToggle from './DarkModeToggle';
import AudioVisualizer from './AudioVisualizer';
import './Header.css'; // We'll create this file next

const Header = () => {
  // Use absolute path for the logo
  const [imagePath, setImagePath] = useState('/images/PRM-Logo-Circle.png');
  const [expanded, setExpanded] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  
  // Debug the image path
  useEffect(() => {
    console.log('Logo image path:', imagePath);
  }, [imagePath]);

  // Handle scroll events
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Only collapse if actively scrolling down and navbar is expanded
      // Check if scroll amount is significant enough to trigger collapse
      if (currentScrollY > lastScrollY && expanded && (currentScrollY - lastScrollY) > 10) {
        setExpanded(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY, expanded]);

  const handleImageError = () => {
    console.log('Image failed to load, trying fallback path');
    // Try the backup location if the original fails
    setImagePath('/PRM-Logo-Circle.png');
  };

  return (
    <Navbar 
      expand="lg" 
      className="custom-navbar py-3" 
      sticky="top"
      expanded={expanded}
      onToggle={(isExpanded) => setExpanded(isExpanded)}
    >
      <Container className="position-relative">
        <div className="brand-container">
          <div className="brand-text">
            <div>Prophetic</div>
            <div>Roundtable</div>
            <div>Ministries</div>
          </div>
          <Navbar.Brand as={Link} to="/" className="brand-logo">
            <img 
              src={imagePath} 
              alt="Prophetic Roundtable Ministries" 
              className="brand-logo-img" 
              onError={handleImageError}
            />
          </Navbar.Brand>
        </div>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={NavLink} to="/" end className="nav-item" onClick={() => setExpanded(false)}>Home</Nav.Link>
            <Nav.Link as={NavLink} to="/mysterion" className="nav-item" onClick={() => setExpanded(false)}>Mysterion</Nav.Link>
            <Nav.Link as={NavLink} to="/blog" className="nav-item" onClick={() => setExpanded(false)}>Bruce's Blog</Nav.Link>
            <Nav.Link as={NavLink} to="/media" className="nav-item" onClick={() => setExpanded(false)}>PRM Media</Nav.Link>
            <Nav.Link as={NavLink} to="/glory-community" className="nav-item" onClick={() => setExpanded(false)}>Glory Community</Nav.Link>
            {/* <Nav.Link as={NavLink} to="/events" className="nav-item" onClick={() => setExpanded(false)}>Events</Nav.Link> */}
            <Nav.Link as={NavLink} to="/stay-connected" className="nav-item" onClick={() => setExpanded(false)}>Stay Connected</Nav.Link>
            <Nav.Link as={NavLink} to="/give" className="nav-item" onClick={() => setExpanded(false)}>Give</Nav.Link>
            <Nav.Link as={NavLink} to="/resources" className="nav-item" onClick={() => setExpanded(false)}>Resources</Nav.Link>
          </Nav>
          <div className="theme-toggle-container">
            <DarkModeToggle />
            <AudioVisualizer />
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header; 